import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import FullScreenLayout from '../../components/FullScreenLayout';
import { useAppointments } from '../../utils/context/AppointmentsContext';
import { useAuth } from '../../utils/context/AuthContext';
import { useUserData } from '../../utils/context/UserDataContext';
import {
  getFormattedDateWithInput,
  handleMissingDays,
} from '../../utils/Functions';
import { useChatNotificationsStore } from '../../utils/stores/useChatNotificationsStore';
import { NewAppointmentWidget } from './components/NewAppointmentWidget';

const Home = () => {
  const { auth } = useAuth();
  const idToken = auth.idToken;
  const { userData } = useUserData();
  const username = userData.name;
  const email = userData.email;
  const { appointmentsState } = useAppointments();
  const allFutureActiveAppointments =
    appointmentsState.allFutureActiveAppointments;
  const allMyFutureAppointments = allFutureActiveAppointments?.filter(
    (app) => app.expert_email === email || app.expert_email === "dr.gentilesalvatore@gmail.com",
  );

  const realName = username === 'Holifya' ? 'Holifya admin 💙' : username;

  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const { unreadSessions } = useChatNotificationsStore();

  // const onGetAllAnswersClick = async () => {
  //   if (!idToken) return
  //   try {
  //     setIsLoading(true)
  //     const answers = await migrateAnswers(idToken)
  //     console.log(answers)
  //     setIsLoading(false)
  //   } catch (error) {
  //     console.log(error)
  //   }
  // }

  if (!allMyFutureAppointments) {
    return (
      <FullScreenLayout title="Home">
        <div className='font-medium text-[20px] leading-[33px]'>
          C'è stato un errore nel recuperare gli appuntamenti. Ti chiediamo di
          riprovare.
        </div>
      </FullScreenLayout>
    );
  }

  if (allMyFutureAppointments.length === 0) {
    return (
      <FullScreenLayout title="Home">
        <div className='font-normal text-[20px] leading-[26px]'>
          Qui potrai visualizzare tutti gli aggiornamenti recenti dei tuoi
          clienti
        </div>
      </FullScreenLayout>
    );
  }

  const futureDay = allMyFutureAppointments[0].date;
  const futureDayAppointments = allMyFutureAppointments.filter(
    (app) =>
      getFormattedDateWithInput(app.date) ===
      getFormattedDateWithInput(futureDay),
  );

  // ********************************************************************************

  return (
    <FullScreenLayout title={`Ciao ${realName}!`}>
      <div className='w-full space-y-[20px]'>
        <div className='font-bold text-[20px] leading-[33px]'>
          In programma {handleMissingDays(futureDayAppointments[0])}
        </div>
        {futureDayAppointments.map((app, index) => (
          <NewAppointmentWidget key={index} appointment={app} />
        ))}
      </div>
    </FullScreenLayout>
  );
};

export default Home;
